import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Col,
} from "reactstrap";
import {
  checkHUIDStock,
  createOrder,
  createOrderProduct,
  getCustomers,
  getProductTypes,
} from "../../../helpers/urlConfig/apiFunctions";
import { successToastify } from "../../../Components/Common/Toaster";
import { getSessionData } from "../../../helpers/sessionDetailsParser";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import errorResponseHandler from "../../../helpers/errorResponseHandler";

function OrderCreate({
  order_modal_list,
  set_order_modal_list,
  order_tog_list,
  fetchData,
  orderProductsDetailsForCreate,
}) {
  const navigate = useNavigate();

  const [customerID, setCustomerID] = useState([]);
  const [selectedCustomerID, setSelectedCustomerID] = useState("");
  const [selectedModeOfPayment, setModeOfPayment] = useState("");

  const [partialAmountChecked, setPartialAmountChecked] = useState(false);
  const [partialAmount, setPartialAmount] = useState("");

  // For each row, we now store unique_stock_id, and either single fields or a pairs array.
  const [productData, setProductData] = useState([
    {
      unique_stock_id: "",
      product_name: "",
      product_type_name: "",
      model_name: "",
      // For single entry products:
      huid: "",
      gram: "",
      // For products with multiple pairs:
      pairs: null,
      quantity: "",
      mc: "",
      amount: "",
    },
  ]);
  // productName will now contain objects that might include a "pairs" property.
  const [productName, setProductName] = useState([]);
  const [goldRate, setGoldRate] = useState("");
  const [silverRate, setSilverRate] = useState("");
  const createdBy = getSessionData("user_id");
  const [disAbled, setDisabled] = useState(false);
  const [orderID, setOrderID] = useState("");
  const [hallMarkChecked, setHallMarkChecked] = useState(false);
  const [hallMarkGST, setHallMarkGST] = useState("");
  const [hallMarkCharge, setHallMarkCharge] = useState("");

  // Update a product row field
  const handleInputChange = (index, field, value) => {
    const newProductData = [...productData];
    newProductData[index][field] = value;
    setProductData(newProductData);
  };

  // Handler for when a unique stock id is selected.
  // It checks whether the selected product has a pairs array or just a single huid/gram.
  const handleUniqueStockChange = (index, selectedValue) => {
    const newProductData = [...productData];
    const selectedProduct = productName.find(
      (item) => item.unique_stock_id === selectedValue
    );

    if (selectedProduct) {
      // Optionally, you can check HUID stock here.
      checkHUIDStock({ huid: selectedProduct.huid });

      if (
        JSON.parse(selectedProduct.pairs) &&
        JSON.parse(selectedProduct.pairs).length > 0
      ) {
        // For products with multiple pairs, set the pairs array.
        newProductData[index] = {
          ...newProductData[index],
          unique_stock_id: selectedProduct.unique_stock_id,
          product_name: selectedProduct.product_name,
          product_type_name: selectedProduct.product_type_name,
          model_name: selectedProduct.model_name,
          // Clear the single fields
          huid: null,
          quantity: selectedProduct.stock,
          gram: selectedProduct.gram,
          pairs: selectedProduct.pairs,
        };
      } else {
        // For products with a single huid/gram.
        newProductData[index] = {
          ...newProductData[index],
          unique_stock_id: selectedProduct.unique_stock_id,
          product_name: selectedProduct.product_name,
          product_type_name: selectedProduct.product_type_name,
          model_name: selectedProduct.model_name,
          huid: selectedProduct.huid,
          gram: selectedProduct.gram,
          pairs: null,
          quantity: selectedProduct.stock,
        };
      }
    }
    setProductData(newProductData);
  };

  const addNewRow = () => {
    if (productData.length < 10) {
      setProductData([
        ...productData,
        {
          unique_stock_id: "",
          product_name: "",
          product_type_name: "",
          model_name: "",
          huid: "",
          gram: "",
          pairs: null,
          quantity: "",
          mc: "",
          amount: "",
        },
      ]);
    }
  };

  const removeRow = (index) => {
    const newProductData = productData.filter((_, i) => i !== index);
    setProductData(newProductData);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!goldRate || !silverRate) {
      alert("Please enter both gold rate and silver rate.");
      return;
    }

    let dataToSubmit;
    let response;

    if (disAbled) {
      dataToSubmit = productData.map((product) => ({
        ...product,
        order_id: orderID,
        customer_id: selectedCustomerID,
        created_by: createdBy,
        gold_rate: goldRate,
        silver_rate: silverRate,
        hall_mark_charge: hallMarkCharge,
        hall_mark_gst: hallMarkGST,
        partial_amount: partialAmountChecked ? partialAmount : null,
      }));

      response = await createOrderProduct(dataToSubmit);
      if (response.statusCode === 200) {
        successToastify("Order Products Created Successfully");
        fetchData();
        set_order_modal_list(false);
      } else {
        errorResponseHandler(response);
      }
    } else {
      dataToSubmit = productData.map((product) => ({
        ...product,
        customer_id: selectedCustomerID,
        created_by: createdBy,
        gold_rate: goldRate,
        silver_rate: silverRate,
        mode_of_payment: selectedModeOfPayment,
        hall_mark_gst: hallMarkGST || "0",
        hall_mark_charge: hallMarkCharge || "0",
        partial_amount: partialAmountChecked ? partialAmount : null,
      }));

      response = await createOrder(dataToSubmit);
      if (response.statusCode === 200) {
        successToastify("Order Created Successfully");
        fetchData();
        set_order_modal_list(false);
      } else {
        errorResponseHandler(response);
      }
    }
  };

  const getProductData = async () => {
    try {
      const response = await getProductTypes();
      const availableProducts = response.data.filter(
        (item) => item.stock > 0 && item.gram > 0 && item.comments !== "Ordered"
      );
      setProductName(availableProducts);
    } catch (error) {
      console.error(error.message);
    }
  };

  const getCustomerData = async () => {
    try {
      const response = await getCustomers();
      if (response?.statusCode === 200) {
        setCustomerID(response.data || []);
      } else {
        errorResponseHandler(response);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  useEffect(() => {
    if (
      orderProductsDetailsForCreate &&
      orderProductsDetailsForCreate.silver_rate_op &&
      orderProductsDetailsForCreate.gold_rate_op &&
      orderProductsDetailsForCreate.customer_id
    ) {
      setSilverRate(orderProductsDetailsForCreate.silver_rate_op);
      setGoldRate(orderProductsDetailsForCreate.gold_rate_op);
      setSelectedCustomerID(orderProductsDetailsForCreate.customer_id);
      setOrderID(orderProductsDetailsForCreate.order_ip_op);
      setHallMarkCharge(orderProductsDetailsForCreate.hall_mark_charge);
      setHallMarkGST(orderProductsDetailsForCreate.hall_mark_gst);
      setModeOfPayment(orderProductsDetailsForCreate.mode_of_payment);
      setDisabled(true);
    }
  }, [orderProductsDetailsForCreate]);

  useEffect(() => {
    getProductData();
    getCustomerData();
  }, []);

  const handleAddNewStockClick = () => {
    navigate("/productType-list");
  };

  const modeOfPayment = [
    { value: "Cash", label: "Cash" },
    { value: "Cheque", label: "Cheque" },
    { value: "IMPS", label: "IMPS" },
    { value: "NEFT", label: "NEFT" },
    { value: "QR", label: "QR" },
    { value: "Card", label: "Card" },
    { value: "Net Banking", label: "Net Banking" },
    { value: "UPI", label: "UPI" },
  ];

  return (
    <Modal
      //size="xl"
      isOpen={order_modal_list}
      toggle={order_tog_list}
      className="modal-fullscreen"
      id="fullscreeexampleModal"
    >
      <ModalHeader toggle={order_tog_list}>Add Orders</ModalHeader>
      <form onSubmit={handleSubmit}>
        <ModalBody>
          <div className="mb-4">
            <Row>
              <Col md={hallMarkChecked ? 2 : 3}>
                <label htmlFor="customer_id">Customer</label>
                <Select
                  options={customerID.map((customer) => ({
                    value: customer.customer_id,
                    label: customer.customer_name,
                  }))}
                  value={
                    selectedCustomerID
                      ? {
                          value: selectedCustomerID,
                          label: customerID.find(
                            (c) => c.customer_id === selectedCustomerID
                          )?.customer_name,
                        }
                      : null
                  }
                  onChange={(selectedOption) =>
                    setSelectedCustomerID(
                      selectedOption ? selectedOption.value : ""
                    )
                  }
                  isDisabled={disAbled}
                  placeholder="Select Customer"
                  required
                />
              </Col>
              <Col md={hallMarkChecked ? 2 : 3}>
                <label htmlFor="gold_rate">Gold Rate</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter the gold rate"
                  id="gold_rate"
                  value={goldRate}
                  disabled={disAbled}
                  onChange={(e) => setGoldRate(e.target.value)}
                  required
                />
              </Col>
              <Col md={hallMarkChecked ? 2 : 3}>
                <label htmlFor="silver_rate">Silver Rate</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter the silver rate"
                  id="silver_rate"
                  value={silverRate}
                  disabled={disAbled}
                  onChange={(e) => setSilverRate(e.target.value)}
                  required
                />
              </Col>
              <Col md={2}>
                <label>Mode Of Payment</label>
                <Select
                  options={modeOfPayment}
                  value={
                    selectedModeOfPayment
                      ? {
                          value: selectedModeOfPayment,
                          label: modeOfPayment.find(
                            (item) => item.value === selectedModeOfPayment
                          )?.label,
                        }
                      : null
                  }
                  onChange={(selectedOption) =>
                    setModeOfPayment(selectedOption ? selectedOption.value : "")
                  }
                  placeholder="Select Mode Of Payment"
                  required
                />
              </Col>
              <Col md={1}>
                <label>Hall Mark</label>
                <br />
                <input
                  style={{ height: "40px" }}
                  onClick={() => setHallMarkChecked(!hallMarkChecked)}
                  type="checkbox"
                />
              </Col>
              {hallMarkChecked && (
                <>
                  <Col md={1}>
                    <label htmlFor="hall_mark_gst">H.M GST %</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter the H.M GST"
                      id="hall_mark_gst"
                      value={hallMarkGST}
                      disabled={disAbled}
                      onChange={(e) => setHallMarkGST(e.target.value)}
                      required
                    />
                  </Col>
                  <Col md={2}>
                    <label htmlFor="hall_mark_charge">Hall Mark Charge</label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Enter the hallmark charge"
                      id="hall_mark_charge"
                      value={hallMarkCharge}
                      disabled={disAbled}
                      onChange={(e) => setHallMarkCharge(e.target.value)}
                      required
                    />
                  </Col>
                </>
              )}
              <Col md={1}>
                <label>Partial Amount</label>
                <br />
                <input
                  style={{ height: "40px" }}
                  onClick={() => setPartialAmountChecked(!partialAmountChecked)}
                  type="checkbox"
                />
              </Col>
              {hallMarkChecked && (
                <>
                  <Col md={1}>{/* ... (existing hall mark GST input) */}</Col>
                  <Col md={partialAmountChecked ? 1 : 2}>
                    {/* ... (existing hall mark charge input, adjusted width) */}
                  </Col>
                </>
              )}
              {partialAmountChecked && (
                <Col md={2}>
                  <label htmlFor="partial_amount">Partial Amount</label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter partial amount"
                    id="partial_amount"
                    value={partialAmount}
                    disabled={disAbled}
                    onChange={(e) => setPartialAmount(e.target.value)}
                    required
                  />
                </Col>
              )}
            </Row>
          </div>

          {productData.map((data, index) => (
            <div key={index} className="border p-3 mb-4">
              <h6>
                Entry {index + 1}{" "}
                <button
                  type="button"
                  className="btn btn-success btn-sm"
                  onClick={handleAddNewStockClick}
                >
                  Add New Stock
                </button>
              </h6>
              <Row className="gy-3">
                <Col md={2}>
                  <label>Unique Stock ID</label>
                  <Select
                    options={productName.map((item) => ({
                      value: item.unique_stock_id,
                      // Customize the label as needed.
                      label: `${item.unique_stock_id} - ${item.product_type_name}`,
                    }))}
                    value={
                      data.unique_stock_id
                        ? {
                            value: data.unique_stock_id,
                            label: `${data.unique_stock_id} - ${data.product_type_name}`,
                          }
                        : null
                    }
                    onChange={(selectedOption) =>
                      handleUniqueStockChange(
                        index,
                        selectedOption ? selectedOption.value : ""
                      )
                    }
                    placeholder="Select Unique Stock ID"
                    required
                  />
                </Col>

                <Col md={2}>
                  <label>Product Type</label>
                  <input
                    type="text"
                    className="form-control"
                    value={data.product_type_name}
                    disabled
                  />
                </Col>

                {/* Conditionally render based on whether the product has multiple pairs */}
                {data.huid === null &&
                JSON.parse(data.pairs) &&
                JSON.parse(data.pairs).length > 0 ? (
                  JSON.parse(data.pairs).map((pair, pairIndex) => (
                    <React.Fragment key={pairIndex}>
                      <Col md={1}>
                        <label>{`HUID ${pairIndex + 1}`}</label>
                        <input
                          type="text"
                          className="form-control"
                          value={pair.huid}
                          disabled
                        />
                      </Col>
                      <Col md={1}>
                        <label>{`Gram ${pairIndex + 1}`}</label>
                        <input
                          type="text"
                          className="form-control"
                          value={pair.gram}
                          disabled
                        />
                      </Col>
                    </React.Fragment>
                  ))
                ) : (
                  <>
                    <Col md={2}>
                      <label>HUID</label>
                      <input
                        type="text"
                        className="form-control"
                        value={data.huid}
                        disabled
                      />
                    </Col>
                    <Col md={1}>
                      <label>Grams</label>
                      <input
                        type="text"
                        className="form-control"
                        value={data.gram}
                        disabled
                      />
                    </Col>
                  </>
                )}

                <Col md={2}>
                  <label>Quantity</label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter the quantity"
                    value={data.quantity}
                    disabled
                    onChange={(e) =>
                      handleInputChange(index, "quantity", e.target.value)
                    }
                    required
                  />
                </Col>

                <Col md={1}>
                  <label>MC</label>
                  <input
                    type="number"
                    placeholder="Enter the MC"
                    className="form-control"
                    value={data.mc}
                    onChange={(e) =>
                      handleInputChange(index, "mc", e.target.value)
                    }
                    required
                  />
                </Col>

                <Col md={2}>
                  <label>Amount</label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter the amount"
                    value={data.amount}
                    onChange={(e) =>
                      handleInputChange(index, "amount", e.target.value)
                    }
                    required
                  />
                </Col>
              </Row>

              {productData.length > 1 && (
                <button
                  type="button"
                  className="btn btn-danger btn-sm mt-2"
                  onClick={() => removeRow(index)}
                >
                  Remove
                </button>
              )}
            </div>
          ))}

          {productData.length < 10 && (
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={addNewRow}
            >
              Add More
            </button>
          )}
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => set_order_modal_list(false)}
          >
            Close
          </button>
          <button type="submit" className="btn btn-success">
            Submit
          </button>
        </ModalFooter>
      </form>
    </Modal>
  );
}

export default OrderCreate;
